import { render } from "./courseItem.vue?vue&type=template&id=0b36d846&scoped=true"
import script from "./courseItem.vue?vue&type=script&lang=js"
export * from "./courseItem.vue?vue&type=script&lang=js"

import "./courseItem.vue?vue&type=style&index=0&id=0b36d846&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b36d846"]])

export default __exports__